var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0232 15.8327C14.4503 15.8327 18.3337 11.9438 18.3337 9.99935C18.3337 8.0549 14.9711 4.16602 10.0232 4.16602C5.33571 4.16602 1.66699 8.0549 1.66699 9.99935C1.66699 11.9438 5.59613 15.8327 10.0232 15.8327ZM10.0004 13.4993C11.9728 13.4993 13.5718 11.9323 13.5718 9.99935C13.5718 8.06635 11.9728 6.49935 10.0004 6.49935C8.02792 6.49935 6.42893 8.06635 6.42893 9.99935C6.42893 11.9323 8.02792 13.4993 10.0004 13.4993Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9845 9.99935C11.9845 11.0732 11.0962 11.9438 10.0004 11.9438C8.90457 11.9438 8.01624 11.0732 8.01624 9.99935C8.01624 8.92546 8.90457 8.0549 10.0004 8.0549C11.0962 8.0549 11.9845 8.92546 11.9845 9.99935Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.129eaa3e889903074be0605d4e0a1ba3.svg";
export { ForwardRef as ReactComponent };